export default __webpack_public_path__ + "static/media/web-development.b4ca44f5.png";